import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useCloseTab } from '../../components/tabs/TabsContext';
import { useApiProgress } from '../../hooks/ApiProgress';
import { toast } from 'react-toastify';
import { VALIDATION_MESSAGE } from '../../utils/constants';
import Spinner from '../../components/Spinner';
import Input from '../../components/Input';
import Button from '../../components/Button';
import { onChange } from '../../utils/functions';
import Textarea from '../../components/Textarea';
import { LOCATION_PATH, getLocationById, updateLocation } from '../../api/locationApi';
import { updateLocationAction } from '../../redux/feature/locationSlice';

const LocationEditPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const { id } = useParams();
    const closeTab = useCloseTab()
    const dispatch = useDispatch()
    const [location, setLocation] = useState({

    })
    const [errors, setErrors] = useState({})
    const pendingApiCall = useApiProgress('put', `${LOCATION_PATH}`, false)
    const pendingApiCallLoading = useApiProgress('get', `${LOCATION_PATH}`, false)

    useEffect(() => {
        getLocationById(id).then(res => setLocation(res.data))
    }, [id])

    const onClickSubmit = () => {
        updateLocation(id, location).then(res => {
            dispatch(updateLocationAction(res.data))
            closeTab()
            toast.success('Lokasyon güncellendi')
        }).catch(err => {
            toast.error(VALIDATION_MESSAGE)
            setErrors(err.response.data.validationErrors)
        })
    }

    if (pendingApiCallLoading) return (
        <div className='flex justify-center'>
            <Spinner />
        </div>
    )

    return (
        <div className='grid grid-cols-1 place-items-center'>
            <div className='col-span-6 w-96'>
                <label className='text-xl mb-5 block'>Lokasyon Düzenle</label>
                <Input
                    label='Lokasyon Kodu'
                    name='code'
                    value={location.code}
                    placeholder='Lokasyon kodu girin'
                    error={errors.code}
                    onChange={e => onChange(e, setLocation, setErrors)}
                />
                <Input
                    label='Lokasyon Adı'
                    name='name'
                    value={location.name}
                    placeholder='Lokasyon adı girin'
                    error={errors.name}
                    onChange={e => onChange(e, setLocation, setErrors)}
                />
                <Textarea
                    label='Açıklama'
                    name='description'
                    value={location.description}
                    placeholder='Açıklama girin'
                    onChange={e => onChange(e, setLocation, setErrors)}
                />
                <div className='flex justify-center'>
                    <Button
                        text='Kaydet'
                        variant='green'
                        onClick={onClickSubmit}
                        pending={pendingApiCall}
                    />
                </div>
            </div>
        </div>
    )
}

export default LocationEditPage